<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['school_mgt'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button
                  v-b-modal.new-feesbreakdown
                  size="sm"
                  variant="primary"
                  ><i class="mdi mdi-plus"></i> New Fees Breakdown</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(fees)="data">
                    {{ commas(data.item.fees.name) }}
                  </template>
                  <template #cell(schoolclass)="data">
                    {{ data.item.schoolclass.name }}
                  </template>
                  <template #cell(schoolterm)="data">
                    {{ data.item.schoolterm.name }} {{ data.item.year }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.fees.id,
                            data.item.schoolclass.id,
                            data.item.schoolterm.id,
                            data.item.year,
                            data.item.entrystatus,
                            data.item.residentialstatus,
                            data.item.amount,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="
                          remove(
                            data.item.id,
                            data.item.fees.name,
                            data.item.schoolclass.name,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-feesbreakdown"
        centered
        title="New Fees Breakdown"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addFeesBreakdown">
          <div class="form-group mb-2">
            <label>Fees</label>
            <multiselect
              v-model="fees"
              label="name"
              :options="feescategories"
            ></multiselect>
            <label>Term</label>
            <multiselect
              v-model="schoolterm"
              label="name"
              :options="schoolterms"
            ></multiselect>
            <label>Year</label>
            <b-form-input v-model="year" type="number"></b-form-input>
            <label>Class</label>
            <multiselect
              v-model="schoolclass"
              label="name"
              :options="schoolclasses"
            ></multiselect>
            <label>Entry Status</label>
            <select class="form-control" v-model="entrystatus">
              <option value="" disabled>Select a Status</option>
              <option value="New">New</option>
              <option value="Continuing">Continuing</option>
            </select>
            <label>Residential Status</label>
            <select class="form-control" v-model="residentialstatus">
              <option value="" disabled>Select a Status</option>
              <option value="Boarding">Boarding</option>
              <option value="Day">Day</option>
            </select>
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-feesbreakdown')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-feesbreakdown"
        centered
        title="Edit Fees Breakdown"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editFeesBreakdown">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Fees</label>
            <v-select
              :options="feescategories"
              placeholder="Select Fees"
              v-model="fees"
              label="name"
              :reduce="(fees) => fees.id"
            ></v-select>
            <label>Term</label>
            <v-select
              :options="schoolterms"
              placeholder="Select Term"
              v-model="schoolterm"
              label="name"
              :reduce="(fees) => fees.id"
            ></v-select>
            <label>Year</label>
            <b-form-input v-model="year" type="number"></b-form-input>
            <label>Class</label>
            <v-select
              :options="schoolclasses"
              placeholder="Select Term"
              v-model="schoolclass"
              label="name"
              :reduce="(fees) => fees.id"
            ></v-select>
            <label>Entry Status</label>
            <select class="form-control" v-model="entrystatus">
              <option value="" disabled>Select a Status</option>
              <option value="New">New</option>
              <option value="Continuing">Continuing</option>
            </select>
            <label>Residential Status</label>
            <select class="form-control" v-model="residentialstatus">
              <option value="" disabled>Select a Status</option>
              <option value="Boarding">Boarding</option>
              <option value="Day">Day</option>
            </select>
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-feesbreakdown')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-feesbreakdown"
        centered
        title="Delete Fees Breakdown"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeFeesBreakdown">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Fees Breakdown :
          <b>{{ schoolclass }} {{ fees }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-feesbreakdown')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  feescategoryMethods,
  feescategoryComputed,
  feesbreakdownMethods,
  feesbreakdownComputed,
  schoolclassMethods,
  schoolclassComputed,
  schooltermMethods,
  schooltermComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Fees Breakdown",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Fees Breakdown",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Fees Breakdown", active: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "fees", label: "Fees", visible: true },
        { key: "schoolterm", label: "Term", visible: true },
        { key: "schoolclass", label: "Class", visible: true },
        { key: "entrystatus", label: "Entry status", visible: true },
        {
          key: "residentialstatus",
          label: "Residential Status",
          visible: true,
        },
        { key: "amount", label: "Amount", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      amount: 0,
      fees: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      schoolclass: "",
      entrystatus: "",
      residentialstatus: "",
    };
  },
  computed: {
    ...feescategoryComputed,
    ...feesbreakdownComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    List() {
      return this.feesbreakdowns.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.feesbreakdowns.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.feesbreakdowns.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchFeesBreakdowns();
    this.fetchFeesCategories();
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.TotalRows = this.feesbreakdowns.length;
    this.isBusy = false;
  },
  methods: {
    ...feescategoryMethods,
    ...feesbreakdownMethods,
    ...schoolclassMethods,
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    commas(x) {
      if (x == null || x == undefined) return "0";
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    edit(
      id,
      fees,
      schoolclass,
      schoolterm,
      year,
      entrystatus,
      residentialstatus,
      amount,
    ) {
      this.id = id;
      this.fees = fees;
      this.schoolclass = schoolclass;
      this.schoolterm = schoolterm;
      this.year = year;
      this.entrystatus = entrystatus;
      this.residentialstatus = residentialstatus;
      this.amount = amount;
      this.$bvModal.show("edit-feesbreakdown");
    },
    remove(id, fees, schoolclass) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.fees = fees;
      this.$bvModal.show("delete-feesbreakdown");
    },
    async addFeesBreakdown() {
      let formData = new FormData();
      formData.append("fees", this.fees.id);
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("entrystatus", this.entrystatus);
      formData.append("residentialstatus", this.residentialstatus);
      formData.append("amount", this.amount);
      let url = "/addfeesbreakdown";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFeesBreakdowns();
          this.$bvModal.hide("new-feesbreakdown");
          this.fees = "";
          this.schoolclass = "";
          this.year = "";
          this.schoolterm = "";
          this.entrystatus = "";
          this.residentialstatus = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editFeesBreakdown() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("fees", this.fees);
      formData.append("schoolterm", this.schoolterm);
      formData.append("year", this.year);
      formData.append("schoolclass", this.schoolclass);
      formData.append("entrystatus", this.entrystatus);
      formData.append("residentialstatus", this.residentialstatus);
      formData.append("amount", this.amount);
      let url = "/updatefeesbreakdown";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFeesBreakdowns();
          this.$bvModal.hide("edit-feesbreakdown");
          this.fees = "";
          this.schoolclass = "";
          this.year = "";
          this.schoolterm = "";
          this.entrystatus = "";
          this.residentialstatus = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeFeesBreakdown() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removefeesbreakdown";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFeesBreakdowns();
          this.$bvModal.hide("delete-feesbreakdown");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
